import Axios from "../utils/request";
import moment from "moment";
import _this from "../main.js";

// console.log("window", window);

// 用户发送反馈
export const sendFeedback = (data) =>
    Axios({
        url: "/app/feedback/sendFeedback",
        method: "post",
        data,
    });

// 用户咨询记录
export const feedbackAndReply = (data) =>
    Axios({
        url: "/app/feedback/feedbackAndReply",
        method: "post",
        data,
    });

// 用户已读
export const userRead = (data) =>
    Axios({
        url: "/app/feedback/userRead",
        method: "post",
        data,
    });

// 用户是否已读
export const isRead = (data) =>
    Axios({
        url: "/app/feedback/isRead",
        method: "post",
        data,
    });

// 埋点
export const saveAppsFlyer = async (data, phone, loan_id) => {
    let channelMap = {
        基础信息提交: "base_success",
        进入基础信息: "base",
        ocr认证: "ocr_auth",
        身份信息提交: "info_success",
        进入身份信息: "info",
        其他信息提交: "other_success",
        进入其他信息: "other",
        进入人脸识别: "face",
        人脸识别完成: "face_success",
        工作信息提交: "work_success",
        进入工作信息: "work",
        申请贷款: "apply_success",
        提现: "withdraw",
        运营商认证完成: "service_auth",
        进入首页: "main_success",
        注册: "register",
        验证码登录: "login_code",
        发送短信: "sms_success",
        密码登录: "login_pwd",
        点击获取VA: "click_va",
        获取VA成功: "va_success",
    };

    if (process.env.VUE_APP_GENRE === "nested") {
        if (loan_id) {
            _this.$tools.postAFEvent(`apply_success|${loan_id}`);
        } else {
            _this.$tools.postAFEvent(channelMap[data]);
        }
        return
    }
    // if (googleConfigChannel.includes(channel)) {
    //   console.log("channel", channel);
    //   window.gtag("event", channelMap[data], {
    //     send_to: googleConfigChannelMap[channel],
    //   });
    // } else

    let regChannleKey;
    if (channelMap[data] == "apply_success") {
        let regChannle = await regChannelMed()
        regChannleKey = regChannle.result.channelKey;
    }

    let channel = localStorage.getItem("channel");
    try {

        let pointByKey = localStorage.getItem("pointByKey")
        if (pointByKey) {
            pointByKey = JSON.parse(pointByKey);

            if (pointByKey.type == 1) {
                if (channelMap[data] == "register") {

                    window.fbq("track", "CompleteRegistration");

                } else if (channelMap[data] == "apply_success" && regChannleKey == channel) {
                    window.fbq("track", "Purchase");
                    window.fbq("track", "SubmitApplication");
                } else {
                    window.fbq("track", channelMap[data]);
                }

            }
        }
    } catch (error) {
        console.log(error);
    }
    let pkg_name;

    if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        pkg_name = "com.loan.xhwloanh5ios";
    } else if (navigator.userAgent.match(/android/i)) {
        pkg_name = "com.loan.xhwloanh5";
    }

    let obj = {
        mobile: phone ? phone : _this.$store.state.user?.userInfo?.phone,
        event_code: channelMap[data],
    };
    Axios({
        url: "/comm/saveAppsFlyer",
        method: "post",
        data: {
            event_source: "H5",
            bundle_id: pkg_name,
            event_revenue_currency: "USD",
            event_name: channelMap[data],
            loan_id,
            app_id: pkg_name,
            is_retargeting: "false",
            event_value: JSON.stringify(obj),
            event_time: moment().format("YYYY-MM-DD HH:mm:ss.SSS"),
        },
    });
};

// 上传定位
export const position = (data) =>
    Axios({
        url: "/fetch/user/position",
        method: "post",
        data,
    });
// 上传短信
export const message = (data) =>
    Axios({
        url: "/fetch/user/message",
        method: "post",
        data,
    });
// 上传相册
export const album = (data) =>
    Axios({
        url: "/fetch/user/album",
        method: "post",
        data,
    });
// 上传通讯录
export const addressbook = (data) =>
    Axios({
        url: "/fetch/user/addressbook",
        method: "post",
        data,
    });
// 获取ip地址
export const getIp = (data) =>
    Axios({
        url: "/comm/getIp",
        method: "post",
        data,
    });

export const logCollection = (data) =>
    Axios({
        url: "/comm/log-collection",
        method: "post",
        data,
    });
export const labelEventSubmit = (data) =>
    Axios({
        url: "/label/event/submit",
        method: "post",
        data,
    });
// 获取注册渠道
export const regChannel = regChannelMed


function regChannelMed(data) {
    return Axios({
        url: "/user/regChannel",
        method: "post",
        data,
    });
}

export const getPointByKey = (data) =>
    Axios({
        url: "/channel/getPointByKey",
        method: "get",
        data,
    });
